import * as React from "react";

import {IPageContainerState} from "@montana/containers/page";
import {Container} from "@montana/shared/container";
import {DynamicBlocks} from "@montana/blocks/dynamic-blocks.component";
import {HeroColourPageModule} from "@montana/pages/colour-page/hero/colour-page-hero.component";
import {IColorContentPage} from "@montana/models/generated/cms.interface";
import cx from "clsx";
import {ColourPageSpecsModule} from "@montana/pages/colour-page/specs/colour-page-specs.component";
import {ColourPageGrid} from "@montana/pages/colour-page/grid/colour-page-grid.component";

export const ColourPage: React.FC<IPageContainerState & IColorContentPage> = React.memo((props: IPageContainerState & IColorContentPage): JSX.Element => {
    const {
        blocks,
        hexCode,
        image,
        color,
        quote,
        colorContentGridBlocks,
        colorDescription,
        surfaceDescription,
        quoteAuthor,
        text,
        colorCodes,
        colorPairing,
    } = props;

    return (
        <Container>
            <div className={cx('app__block', 'app__block--break-container', 'app__block--m01-hero-block')}>

                <HeroColourPageModule
                    image={image}
                    backgroundColorHex={hexCode}
                    color={color}
                    quote={quote}
                    quoteAuthor={quoteAuthor}
                />
                <ColourPageSpecsModule colorDescription={colorDescription}
                                       surfaceDescription={surfaceDescription}
                                       colorCodes={colorCodes}
                                       colorPairing={colorPairing}
                                       color={color}
                />
                <ColourPageGrid header={text} blocks={colorContentGridBlocks}/>
            </div>
            <DynamicBlocks blocks={blocks}/>
        </Container>
    );
});
